import { render } from "./editProcess.vue?vue&type=template&id=3bc98b08&scoped=true&ts=true"
import script from "./editProcess.vue?vue&type=script&lang=ts"
export * from "./editProcess.vue?vue&type=script&lang=ts"

import "./editProcess.vue?vue&type=style&index=0&id=3bc98b08&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc98b08"]])

export default __exports__